// extracted by mini-css-extract-plugin
export default {"popupWindow":"modal_popupWindow__26iNj","popupWindow_type_wide":"modal_popupWindow_type_wide__blTQW","popupWindow__closeBtn":"modal_popupWindow__closeBtn__7AFnO"};